module.exports = __webpack_public_path__ + "static/media/successBig.233ae859.svg";